import React, { useState, useEffect } from 'react'
import { Button, Container, Card, Row, Col } from 'react-bootstrap'
import ApiEndpoints, {BASE_URL, BASE_URL_Upload} from './commonComponents/ApiEndpoints'
import { useLocation, useNavigate, useParams } from 'react-router-dom'
import { FaArrowLeft } from 'react-icons/fa'
import toast from 'react-hot-toast'
import axios from 'axios'
import Cookies from 'js-cookie'
import { useAuth } from './AuthContext'

const UpdateStudentEnquiry = () => {
  const {token} = useAuth()
  const [marginLeft, setMarginLeft] = useState(
    window.innerWidth > 768 ? '300px' : '0px',
  )

  useEffect(() => {
    const handleResize = () => {
      setMarginLeft(window.innerWidth > 768 ? '270px' : '0px')
    }

    window.addEventListener('resize', handleResize)
    return () => window.removeEventListener('resize', handleResize)
  }, [])

  const { student_id } = useParams()
  console.log('Student ID:', student_id)

  const location = useLocation()
  const enquiryData = location.state?.enquiry || location.state?.data
  console.log('Enquiry Data:', enquiryData)
  const navigate = useNavigate()

  const [formData, setFormData] = useState({
    ...enquiryData,

    // student_id: student_id,
  })
  const [studentImage, setStudentImage] = useState(null)
  const [courseTouched, setCourseTouched] = useState(false)
  const [countColor, setCountColor] = useState('') // Add color for the response
  const [errors, setErrors] = useState({})

  const [institutes, setInstitutes] = useState([])

  const [courses, setCourses] = useState([])
  const [classes, setClasses] = useState([])
  const [studentCount, setStudentCount] = useState(null)

  const [selectedNewCourse, setSelectedNewCourse] = useState([])

  useEffect(() => {
    const institueId = Cookies.get('institute_id')
    const userCookie = Cookies.get('user')
    let token = null
    console.log('InstituteID', institueId)

    if (userCookie) {
      try {
        const user = JSON.parse(userCookie)
        token = user.token
        console.log('TOKEN:', token)
      } catch (err) {
        console.error(' Failed to parse user cookie', err)
      }
    } else {
      console.warn('user cookie not found')
    }

    const fetchFilteredData = async () => {
      console.log('Insti ID: ', institueId)
      try {
        const headers = {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${token}`,
          institute_id: Number(institueId),
        }

        console.log('Request Headers:', headers)

        const response = await axios.get(
          BASE_URL+'/student/all',
          { headers },
        )
        const students = response.data.data
        const matchedStudent = students.find(
          (std) => std.id === Number(student_id),
        )
        if (matchedStudent) {
          setFormData({
            ...matchedStudent,
            course_id: matchedStudent.course_id,
            class_id: matchedStudent.class_id,
          })
        } else {
          console.error('Student not found')
        }
      } catch (error) {
        toast.error(error.response?.data?.message || 'Something went wrong')
      }
    }

    if (student_id) {
      fetchFilteredData()
    }
  }, [student_id])

  useEffect(() => {
    if (enquiryData) {
      setFormData(enquiryData)
    }
  }, [enquiryData])

  useEffect(() => {
    ApiEndpoints.getAllClasses().then((res) => setClasses(res.data.data))
    ApiEndpoints.getAllCourses().then((res) => setCourses(res.data.data))
  }, [])
  useEffect(() => {
    ApiEndpoints.getAllInstitutes().then((res) => {
      if (Array.isArray(res.data.data)) {
        setInstitutes(res.data.data)
      } else {
        setInstitutes([]) // Fallback to empty array
      }
    })
  }, [])

  const calculateAge = (dob) => {
    if (!dob) return ''
    const birthDate = new Date(dob)
    const today = new Date()
    let age = today.getFullYear() - birthDate.getFullYear()
    const monthDiff = today.getMonth() - birthDate.getMonth()

    if (
      monthDiff < 0 ||
      (monthDiff === 0 && today.getDate() < birthDate.getDate())
    ) {
      age--
    }
    return age
  }

  const handleBack = () => {
    navigate('/AddStudent')
  }

  const handleSaveAsStudent = async (e) => {
    e.preventDefault()
    const newErrors = {}

    if (!formData.course_id) newErrors.course_id = true
    if (!formData.class_id) newErrors.class_id = true

    if (Object.keys(newErrors).length) {
      setErrors(newErrors)
      toast.error('Please fill required fields.')
      return
    }

    try {
      let imageUrl = null
      if (studentImage) {
        if (studentImage.size > 2 * 1024 * 1024) {
          toast.error('Image size should not exceed 2MB.')
          return
        }
        const formData = new FormData()
        formData.append('image', studentImage)
        formData.append('folder', 'student')
        for (let [key, value] of formData.entries()) {
          console.log(`${key}:`, value)
        }
        const imageResponse = await axios.post(
          BASE_URL+'/upload-image',
          formData,
        )
        imageUrl = BASE_URL_Upload + `/${imageResponse.data.path}`
        console.log('IMGURL', imageUrl)
      }
      const payload = {
        // ...updatedStudent,
        ...formData,
        student_image: imageUrl,
        enquiry_id: enquiryData ? enquiryData?.id : student_id,
      }
      console.log('Sending data: ', payload)
      console.log('Student ID in payload:', payload.id)

      const response = await ApiEndpoints.editStudent(payload.id, payload)
      toast.success(response.data.message)
      navigate('/AddStudent')
    } catch (error) {
      toast.error(error.response?.data?.message)
    }
  }

  useEffect(() => {
    setSelectedNewCourse(formData.course_id)
  }, [])

  const shouldDisableCourseAndClass =
    formData.course_id !== null &&
    formData.course_id !== '' &&
    formData.class_id !== null &&
    formData.class_id !== ''

  const handleCourseChange = (e) => {
    const courseId = e.target.value
    setFormData((prev) => ({ ...prev, course_id: courseId }))

    console.log('Selected course Id:', courseId)
    setCourseTouched(true)
    setSelectedNewCourse(courseId)
    setStudentCount(null)
    console.log('Cleared Classes')

    if (courseId) {
      ApiEndpoints.getAllClassesByCourseId(courseId)
        .then((res) => {
          const { data } = res
          if (data.status === false || !data.data?.length) {
            // toast.error('No classes found for this course.')
            setClasses([])
            setStudentCount(null)
          } else {
            setClasses(data.data)
            // setFormData(data.data)
          }
        })
        .catch((error) => {
          // This is where 404 or other errors come
          if (
            error.response?.data?.message === 'No classes found for this course'
          ) {
            // toast.error('No classes found for this course.')
          } else {
            console.error('Error fetching classes:', error)
            // toast.error('Something went wrong while fetching classes.')
          }
          setClasses([])
        })
    }
  }

  const handleClassChange = (e) => {
    const classId = e.target.value
    setFormData((prev) => ({ ...prev, class_id: classId }))

    // Clear previous student count
    setStudentCount(null)
    setCountColor('')

    if (classId) {
      // Call the API to get the student count for the selected class
      fetch(
        BASE_URL+`/get/class/student/count?class_id=${classId}`,{
        headers :
          {
          Authorization: `Bearer ${token}`
        }
      } 
      )
        .then((response) => response.json())
        .then((data) => {
          if (
            data?.status &&
            data?.data?.current !== undefined &&
            data?.data?.maximum_limit !== undefined
          ) {
            const current = data.data.current === null ? 0 : data.data.current // Treat null as 0
            const maximum_limit = parseInt(data.data.maximum_limit, 10) // Parse maximum_limit as a number
            setStudentCount({ current, maximum_limit }) // Set the state with correct property names
            setCountColor('green') // Example color for success
          } else {
            setStudentCount('No data available')
            setCountColor('red') // Example color for no data
          }
        })
        .catch((error) => {
          console.error('Error fetching student count:', error)
          setStudentCount('Error fetching data')
          setCountColor('red') // Example color for error
        })
    }
  }

  const handleNavigateToCreateClass = () => {
    navigate('/AddClass')
  }
  return (
    <>
      <style>
        {`
          .hover-button:hover {
            box-shadow: 0 0.5rem 1rem rgba(0,0,0,0.15);
            transform: scale(1.02);
            transition: all 0.2s ease-in-out;
          }

           .blinking-link {
            color: blue;
            text-decoration: none;
            cursor: pointer;
            animation: blink 1s infinite;
            font-weight:bold;
          }

          @keyframes blink {
            0% { color: blue; }
            50% { color: red; }
            100% { color: blue; }
          }

        `}
      </style>

      <div style={{ marginLeft }}>
        {enquiryData || student_id ? (
          <>
            <div
              className="container-fluid p-0"
              style={{
                marginTop: window.innerWidth < 768 ? '55px' : '-12px',
              }}
            >
              <div className="bg-secondary p-3 rounded d-flex flex-wrap justify-content-between align-items-center text-white">
                <div className="m-0">
                  <h2 className="mb-0">
                    Update{' '}
                    <span className="text-warning">
                      {formData.name
                        ? formData.name.charAt(0).toUpperCase() +
                          formData.name.slice(1).toLowerCase()
                        : ''}
                    </span>
                    's Profile
                  </h2>
                </div>
                <Button
                  variant="outline-light"
                  className=" border-white"
                  onClick={handleBack}
                >
                  <FaArrowLeft /> Go to Student List
                </Button>
              </div>
            </div>
            <Container className="mt-4">
              <Card className="border-0 shadow-sm">
                <Card.Body>
                  <Row className="align-items-center text-center text-md-start">
                    <Col md={2} className="text-center mt-4 mb-2">
                      <label
                        htmlFor="studentImageInput"
                        style={{ cursor: 'pointer' }}
                      >
                        {formData.student_image || studentImage ? (
                          <img
                            src={
                              studentImage
                                ? URL.createObjectURL(studentImage)
                                : formData.student_image
                            }
                            className="rounded-circle border border-3 shadow-sm"
                            alt="Profile"
                            style={{
                              width: '120px',
                              height: '120px',
                              border: '3px solid #007bff',
                              objectFit: 'cover',
                              background: 'white',
                            }}
                          />
                        ) : (
                          <div
                            className="d-flex align-items-center justify-content-center rounded-circle border border-3 shadow-sm"
                            style={{
                              width: '120px',
                              height: '120px',
                              border: '3px solid #007bff',
                              background: 'white',
                              textAlign: 'center',
                              fontSize: '14px',
                              color: '#6c757d',
                            }}
                          >
                            Photo not available
                          </div>
                        )}
                      </label>
                      <input
                        type="file"
                        id="studentImageInput"
                        accept="image/*"
                        style={{ display: 'none' }}
                        onChange={(e) => {
                          const file = e.target.files[0]
                          if (file) {
                            if (file.size > 2 * 1024 * 1024) {
                              toast.error('Image size should not exceed 2MB.')
                              return
                            }
                            setStudentImage(file)
                          }
                        }}
                      />
                    </Col>

                    <Col md={8}>
                      {/* <h4 className="mb-0">
                        {enquiryData?.name.toUpperCase() || 'N/A'}
                      </h4> */}
                      <h4 className="mb-0">
                        {(formData?.name || '').toUpperCase() || 'N/A'}
                      </h4>
                    </Col>
                  </Row>

                  {/* General Information */}
                  <Row className="d-flex align-items-center justify-content-between">
                    <Col>
                      <h4 className="text-primary mt-4 mb-4 text-start h-100">
                        General Information
                      </h4>
                    </Col>
                  </Row>
                  <Row className="g-3">
                    <Col md={3} xs={6}>
                      <div className="p-2 border rounded bg-white text-start h-100">
                        <small className="text-muted">Institute Name</small>
                        <select
                          className="form-control"
                          value={formData.institute_id || ''}
                          onChange={(e) =>
                            setFormData({
                              ...formData,
                              institute_id: e.target.value,
                            })
                          }
                        >
                          <option value="">Select Institute</option>
                          {institutes.map((inst) => (
                            <option
                              key={inst.institute_id}
                              value={inst.institute_id}
                            >
                              {inst.name}
                            </option>
                          ))}
                        </select>
                      </div>
                    </Col>
                    <Col md={3} xs={6}>
                      <div className="p-2 border rounded bg-white text-start h-100">
                        <small className="text-muted">Admission Number</small>
                        <input
                          type="text"
                          className="form-control"
                          value={formData.admission_number || ''}
                          onChange={(e) =>
                            setFormData({
                              ...formData,
                              admission_number: e.target.value,
                            })
                          }
                        />
                      </div>
                    </Col>
                    <Col md={3} xs={6}>
                      <div className="p-2 border rounded bg-white text-start h-100">
                        <small className="text-muted">Admission Date</small>
                        <input
                          type="date"
                          className="form-control"
                          value={formData.admission_date || ''}
                          onChange={(e) =>
                            setFormData({
                              ...formData,
                              admission_date: e.target.value,
                            })
                          }
                        />
                      </div>
                    </Col>
                    <Col md={3} xs={6}>
                      <div className="p-2 border rounded bg-white text-start h-100">
                        <small className="text-muted">Email Address</small>
                        <input
                          type="email"
                          className="form-control"
                          value={formData.email || ''}
                          onChange={(e) =>
                            setFormData({ ...formData, email: e.target.value })
                          }
                        />
                      </div>
                    </Col>
                    <Col md={3} xs={6}>
                      <div className="p-2 border rounded bg-white text-start h-100">
                        <small className="text-muted">Gender</small>
                        <select
                          className="form-control"
                          value={formData.gender || ''}
                          onChange={(e) =>
                            setFormData({ ...formData, gender: e.target.value })
                          }
                        >
                          <option value="">Select Gender</option>
                          <option value="male">Male</option>
                          <option value="female">Female</option>
                          <option value="other">Other</option>
                        </select>
                      </div>
                    </Col>

                    <Col md={3} xs={6}>
                      <div className="p-2 border rounded bg-white text-start h-100">
                        <small className="text-muted">Birth Date</small>
                        <input
                          type="date"
                          className="form-control"
                          value={formData.dob || ''}
                          onChange={(e) =>
                            setFormData({ ...formData, dob: e.target.value })
                          }
                        />
                      </div>
                    </Col>
                    <Col md={3} xs={6}>
                      <div className="p-2 border rounded bg-white text-start h-100">
                        <small className="text-muted">Age</small>
                        <p className="mb-0">
                          {calculateAge(formData?.dob) || 'N/A'}
                        </p>
                      </div>
                    </Col>
                    <Col md={3} xs={6}>
                      <div className="p-2 border rounded bg-white text-start h-100">
                        <small className="text-muted">Address</small>
                        <input
                          type="text"
                          className="form-control"
                          value={formData.address || ''}
                          onChange={(e) =>
                            setFormData({
                              ...formData,
                              address: e.target.value,
                            })
                          }
                        />
                      </div>
                    </Col>
                    <Col md={3} xs={6}>
                      <div className="p-2 border rounded bg-white text-start h-100">
                        <small className="text-muted">ID Poof Number</small>
                        <p className="mb-0">
                          <input
                            type="text"
                            className="form-control"
                            value={formData.id_proof_number || ''}
                            onChange={(e) =>
                              setFormData({
                                ...formData,
                                id_proof_number: e.target.value,
                              })
                            }
                          />
                        </p>
                      </div>
                    </Col>

                    <Col md={3} xs={6}>
                      <div className="p-2 border rounded bg-white text-start h-100">
                        <small className="text-muted">Father's Name</small>
                        <p className="mb-0">
                          <input
                            type="text"
                            className="form-control"
                            value={formData.father_name || ''}
                            onChange={(e) =>
                              setFormData({
                                ...formData,
                                father_name: e.target.value,
                              })
                            }
                          />
                        </p>
                      </div>
                    </Col>
                    <Col md={3} xs={6}>
                      <div className="p-2 border rounded bg-white text-start h-100">
                        <small className="text-muted">Mother's Name</small>
                        <p className="mb-0">
                          <input
                            type="text"
                            className="form-control"
                            value={formData.mother_name || ''}
                            onChange={(e) =>
                              setFormData({
                                ...formData,
                                mother_name: e.target.value,
                              })
                            }
                          />
                        </p>
                      </div>
                    </Col>

                    <Col md={3} xs={6}>
                      <div className="p-2 border rounded bg-white text-start h-100">
                        <small className="text-muted">Phone Number</small>
                        <input
                          type="text"
                          className="form-control"
                          value={formData.phone || ''}
                          onChange={(e) =>
                            setFormData({ ...formData, phone: e.target.value })
                          }
                        />
                      </div>
                    </Col>
                    <Col md={3} xs={6}>
                      <div className="p-2 border rounded bg-white text-start h-100">
                        <small className="text-muted">Parent's Number</small>
                        <p className="mb-0">
                          <input
                            type="text"
                            className="form-control"
                            value={formData.parents_number || ''}
                            onChange={(e) =>
                              setFormData({
                                ...formData,
                                parents_number: e.target.value,
                              })
                            }
                          />
                        </p>
                      </div>
                    </Col>
                    <Col md={3} xs={6}>
                      <div className="p-2 border rounded bg-white text-start h-100">
                        <small className="text-muted">WhatsApp Number</small>
                        <p className="mb-0">
                          <input
                            type="text"
                            className="form-control"
                            value={formData.whatsapp_number || ''}
                            onChange={(e) =>
                              setFormData({
                                ...formData,
                                whatsapp_number: e.target.value,
                              })
                            }
                          />
                        </p>
                      </div>
                    </Col>

                    <Col md={3} xs={6}>
                      <div className="p-2 border rounded bg-white text-start h-100">
                        <small>Course Name</small>
                        <select
                          className={`form-select ${
                            errors.course_id ? 'border-danger' : ''
                          }`}
                          value={formData.course_id?.toString() || ''}
                          // value={selectedNewCourse}
                          onChange={handleCourseChange}
                          required
                          disabled={shouldDisableCourseAndClass}
                        >
                          <option value="">Select Course</option>
                          {courses.map((course) => (
                            <option
                              key={course.id}
                              value={course.id.toString()}
                            >
                              {course.name}
                            </option>
                          ))}
                        </select>
                      </div>
                    </Col>

                    <Col md={3} xs={6}>
                      <div className="p-2 border rounded bg-white text-start h-100">
                        <small>Class Name</small>
                        <select
                          className={`form-select ${
                            errors.course_id ? 'border-danger' : ''
                          }`}
                          // value={formData.classId || ''}
                          value={formData.class_id?.toString() || 'N/A'}
                          onChange={handleClassChange}
                          required
                          disabled={
                            shouldDisableCourseAndClass ||
                            !courseTouched ||
                            classes.length === 0
                          }
                        >
                          <option value="">Select Class</option>
                          {classes.map((cls) => (
                            <option key={cls.id} value={cls.id.toString()}>
                              {cls.class_name}
                            </option>
                          ))}
                        </select>
                      </div>
                    </Col>

                    <Col md={3} xs={6}>
                      <div className="p-2 border rounded bg-white text-start h-100">
                        <small className="text-muted">Status</small>
                        {formData?.status ? (
                          <p className="mb-0 text-success">
                            {formData.status.charAt(0).toUpperCase() +
                              formData.status.slice(1).toLowerCase()}
                          </p>
                        ) : null}
                      </div>
                    </Col>
                    <Col md={6} xs={1}>
                      <div className="p-2  bg-white text-start h-100">
                        {classes.length === 0 &&
                          selectedNewCourse &&
                          courseTouched && (
                            <p style={{ color: 'red', letterSpacing: '1px' }}>
                              The selected course has no class. Please{' '}
                              <span
                                className="blinking-link"
                                onClick={handleNavigateToCreateClass}
                              >
                                click here
                              </span>{' '}
                              to create new class.
                            </p>
                          )}

                        {studentCount !== null &&
                          studentCount !== 'No data available' && (
                            <div
                              style={{
                                color: countColor,
                                marginBottom: '5px',
                                fontWeight: 'bold',
                                letterSpacing: '1px',
                              }}
                            >
                              {studentCount.current === null
                                ? `There are still ${studentCount.maximum_limit} seats available in this class.`
                                : studentCount.current ===
                                  studentCount.maximum_limit
                                ? 'There are no more seats available in this class.'
                                : `There are ${
                                    studentCount.maximum_limit -
                                    studentCount.current
                                  } seats left in this class.`}
                            </div>
                          )}
                      </div>
                    </Col>
                  </Row>
                </Card.Body>
                <Button
                  type="submit"
                  className="fw-bold"
                  style={{ letterSpacing: '1px' }}
                  onClick={handleSaveAsStudent}
                >
                  Save as Student
                </Button>
              </Card>
            </Container>
          </>
        ) : (
          <p>Loading student data...</p>
        )}
      </div>
    </>
  )
}

export default UpdateStudentEnquiry
